import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './MoreText.pcss';
export const MoreText = ({ text, maxLineCount }) => {
    const formattedText = text.replace(/\n/g, '<br />');
    const lineCount = formattedText.split('<br />').length;
    return _jsxs(_Fragment, { children: [_jsx("span", { dangerouslySetInnerHTML: { __html: formattedText.split('<br />').slice(0, maxLineCount).join('<br />') } }), lineCount > maxLineCount && _jsx("span", { className: 'new-store-card__more-text', children: " & more" })] });
};
